var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Geschlecht","items":_vm.genderOptions,"rules":_vm.rules},model:{value:(_vm.genderProxy),callback:function ($$v) {_vm.genderProxy=$$v},expression:"genderProxy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }